[
  {
    "title": "Spotify",
    "href": "https://open.spotify.com/show/2IYi1DtMn0vfwZ0L9mKLyi?si=T7CKhdHkSzSUrAVTXh04wg",
    "icon": "spotify"
  },
  {
    "title": "Apple",
    "href": "https://podcasts.apple.com/us/podcast/the-thorne-podcast/id1479869759",
    "icon": "apple"
  }
]
